
import { Fragment, useState, useEffect } from 'react'
import { Dialog, Popover, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { ArrowPathIcon, ChartPieIcon, CursorArrowRaysIcon, FingerPrintIcon, SquaresPlusIcon } from '@heroicons/react/24/outline'
import { PhoneIcon, ArrowLeftIcon } from '@heroicons/react/20/solid'
import { Link, useLocation } from 'react-router-dom'

const navigation = [
  { name: 'محصولات', href: '#' },
  { name: 'درباره ما', href: '/about' },
  { name: 'تماس با ما', href: '/contact' },
]

const products = [
  { name: 'سونوگرافی', description: '', href: '/page/6', icon: ArrowPathIcon },
  { name: 'الکتروکاردیوگراف و اسپیرومتری', description: '', href: '/page/1', icon: ChartPieIcon },
  { name: 'فتال مانیتورینگ', description: '', href: '/page/2', icon: CursorArrowRaysIcon },
  { name: 'پالس اکسیمتر', description: '', href: '/page/3', icon: FingerPrintIcon },
  { name: 'هولتر مانیتورینگ فشار خون', description: '', href: '/page/4', icon: SquaresPlusIcon },
  { name: 'سونیکید', description: '', href: '/page/5', icon: ArrowPathIcon },
]

const callsToAction = [
  { name: 'موارد بیشتر', href: '#', icon: ArrowLeftIcon },
  // { name: 'Contact sales', href: '#', icon: PhoneIcon },
]

export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation()
    const isHomePage = location.pathname === '/'

    // Listen for scroll events and toggle sticky header
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50); // Adjust threshold as needed
      };

      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    return(
      <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
              isScrolled || !isHomePage ? 'bg-white text-gray-900' : 'bg-transparent text-white'}`}>        
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <div className="flex lg:flex-1"> 
            <Link to='/' className='flex items-center'>
              <img src={ isScrolled || !isHomePage ? "/assets/images/logo.png" : "/assets/images/logo-dark.png"} class="rtl: ml-3 ltr:mr-3 h-6 sm:h-12" alt="Shamim salamat pasargad" />
              {/* <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">شمیم سلامت پاسارگاد</span> */}
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <Popover.Group className="hidden lg:flex lg:gap-x-12">
          <Popover className="relative">
            {({ close }) => (
              <>
            <Popover.Button className={`flex items-center gap-x-1 text-sm font-semibold leading-6 ${isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'}`}>
              <span>محصولات</span>
              <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
            </Popover.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute ltr:-left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="p-4">
                  {products.map((item) => (
                    <div
                      key={item.name}
                      className="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-gray-50"
                    >
                      <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" aria-hidden="true" />
                      </div>
                      <div className="flex-auto">
                        <Link to={item.href} className="block font-semibold text-gray-900" onClick={() => close()}>
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                        <p className="mt-1 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                  {callsToAction.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                      onClick={() => close()}
                    >
                      <item.icon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                      {item.name}
                    </Link>
                  ))}
                </div>
              </Popover.Panel>
            </Transition>
            </>
            )}
          </Popover>
          
          <Link to='/about' className={`text-sm font-semibold leading-6 ${isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'}`}>درباره ما</Link> 
          <Link to='/contact' className={`text-sm font-semibold leading-6 ${isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'}`}>تماس با ما</Link> 
          
          </Popover.Group>          
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            {/* <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
              Log in <span aria-hidden="true">&rarr;</span>
            </a> */}
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
                <span className="sr-only">Shamim Salamat Pasargad</span>
                <img
                  className="h-8 w-auto"
                  src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                  alt=""
                />
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                {/* <div className="py-6">
                  <a
                    href="#"
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  >
                    Log in
                  </a>
                </div> */}
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    )
}